<template>
  <v-container class="contenedor" fluid>
    <div v-if="loading">
      <AnimacionCarga />
    </div>
    <v-row v-if="!loading">
      <!--------------- barra lateral --------------------->
      <v-col md="12" sm="12" cols="12" class="d-lg-none" order="first" order-sm="first" order-md="first">
        <div class="d-flex justify-center ">
          <img class="logoEmulsa" src="../../assets/imagenes/Logotipo.svg" alt="Logo Emulsa" />
        </div>
      </v-col>
      <v-col xl="3" lg="3" md="12" sm="12" cols="12" class="lateral" order="last" order-sm="last" order-md="last">
        <div class="d-lg-flex justify-center py-6 d-none">
          <img class="logoEmulsa" src="../../assets/imagenes/Logotipo.svg" alt="Logo Emulsa" />
        </div>
        <div class="d-flex justify-center px-4 pb-4 pt-sm-4 pt-md-4 pt-xs-4 pt-4 pt-xl-0 pt-lg-0">
          <v-text-field class="buscador" v-model="filtro" label="Buscar comercio" solo rounded hide-details
            append-icon="fa-solid fa-magnifying-glass"></v-text-field>
        </div>

        <div class="panelComercios px-6 py-0">

          <div v-for="(comercio, i) in comerciosFiltrados" :key="i">
            <div class="d-flex justify-space-between py-3">
              <div class="d-flex">

                <!-- <v-avatar>
                  <img class="imagenComercioLista" :src="comercio.foto || '../../assets/imagenes/noImagen.svg'"
                    alt="imagen comercio" />
                </v-avatar> -->


                <div class="d-flex flex-column pl-2">
                  <p class="tituloComercios align-self-start">{{ comercio.nombre }}</p>
                  <p class="datosComercios align-self-start">{{ comercio.direccion }}</p>
                </div>


              </div>



              <div @click="clickPanel(comercio)" class="d-flex justify-end">
                <v-icon color="primary" class="iconExpand">fa-solid fa-circle-xmark</v-icon>
              </div>

            </div>
            <v-divider v-if="i < (comerciosFiltrados.length - 1)"></v-divider>

          </div>



        </div>
        <div class="d-flex justify-center pt-4">
          <img class="logoReusapp align-self-end" src="../../assets/imagenes/LogotipoReusapp.svg" alt="Logo Reusapp" />
        </div>

      </v-col>
      <!--------------- zona mapa --------------------->
      <v-col xl="9" lg="9" md="12" sm="12" cols="12" class="pa-0 " order="first" order-sm="first" order-md="first"
        order-lg="last" order-xl="last">
        <!--------------- chips --------------------->
        <div class="d-lg-flex justify-center d-none">
          <v-chip-group mandatory class="chips" v-model="categoriaSeleccionada"
            prev-icon="fa-solid fa-circle-chevron-right" next-icon="fa-solid fa-circle-chevron-left">
            <v-chip value="0">
              Todas
            </v-chip>
            <v-chip v-for="categoria in listaCategoriasActivasComercios" :key="categoria.id" :value="categoria.id">
              {{ categoria.nombre }}
            </v-chip>
          </v-chip-group>



        </div>

        <div class="d-lg-none d-flex">
          <v-chip-group mandatory class="d-lg-none chipsMovil" v-model="categoriaSeleccionada"
            prev-icon="fa-solid fa-circle-chevron-right" next-icon="fa-solid fa-circle-chevron-left">
            <v-chip value="0">
              Todas
            </v-chip>
            <v-chip v-for="categoria in listaCategoriasActivasComercios" :key="categoria.id" :value="categoria.id">
              {{ categoria.nombre }}
            </v-chip>
          </v-chip-group>
        </div>



        <!--------------- mapa --------------------->
        <GmapMap :center="{ lat: 43.53232, lng: -5.66111 }" :zoom="14" map-type-id="roadmap" class="mapa">
          <template v-for="(comercio, i) of comerciosFiltrados">
            <gmap-custom-marker class="marcador" :class="{ 'marcador-seleccionado': comercioSeleccionado === comercio }"
              :marker="{ lat: comercio.latitud, lng: comercio.longitud }" :key="i"
              @click.native="clickMarcador(comercio)">
            </gmap-custom-marker>
          </template>
        </GmapMap>
      </v-col>
    </v-row>
    <!---------------- dialog comercios ------------->
    <v-dialog v-model="dialogComercios" overlay-opacity="0">
      <v-card class="cardComercios" elevation="3">

        <div @click="cerrarDialog()" class="divCerrar">
          <v-avatar color="primary" class="iconCerrar"><i class="fa-solid fa-xmark"
              style="color: #ffffff;"></i></v-avatar>
        </div>


        <v-card-title class="pa-0">
          <v-img v-if="this.comercioSeleccionado.foto != null && this.comercioSeleccionado.foto != ''"
            class="imagenComercio" :src="this.comercioSeleccionado.foto" />
          <img v-else class="imagenComercio" src="../../assets/imagenes/noImagen.svg" alt="no imagen" />
        </v-card-title>

        <v-card-text class="black--text pt-4 pb-4">
          <v-row>
            <v-col cols="8" class="descripcion">
              <v-card-title class="tituloComercioPopUp">
                {{ this.comercioSeleccionado.nombre }}
              </v-card-title>
              <v-card-text class="datosComercio mt-2">
                {{ this.comercioSeleccionado.direccion }}
              </v-card-text>

            </v-col>
            <v-col cols="4" class="">
              <v-btn text class="ruta" @click="comoLlegar()">
                <v-icon class="iconoRuta mr-2" color="#fff">
                  fa fa-location-arrow
                </v-icon>
                Ruta
              </v-btn>
            </v-col>
            <v-col cols="12" class="descripcion2 mt-2 pr-4">
              <v-card-text class="descripcionComercio">
                {{ this.comercioSeleccionado.descripcion }}
              </v-card-text>
            </v-col>
            <v-col cols="4" class="btnPopUp">
              <div v-if="this.comercioSeleccionado.telefono" class="botonesDetalle">
                <v-icon class="mt-3 mr-3" color="#0072B9">
                  fa-phone
                </v-icon>
                <a type="tel" class="tlfDetalle" style="text-decoration:none"
                  v-text="`${this.comercioSeleccionado.telefono}`" :href="`tel:${this.comercioSeleccionado.telefono}`" />
              </div>
              <div v-if="this.comercioSeleccionado.email" class="botonesDetalle">
                <v-icon class="mt-3 mr-3" color="#0072B9">
                  fas fa-envelope
                </v-icon>
                <a type="mailto" class="emailDetalle" id="email" v-text="`${this.comercioSeleccionado.email}`"
                  style="text-decoration:none" @click="enviarEmail()" />
              </div>
              <div v-if="this.comercioSeleccionado.web" class="botonesDetalle">
                <v-icon class="mt-3 mr-3 " color="#0072B9">
                  fa-solid fa-globe
                </v-icon>
                <a type="web" class="webDetalle" v-text="`${this.comercioSeleccionado.web}`" style="text-decoration:none"
                  @click="irWeb()" />
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { Geolocation } from '@capacitor/geolocation';
import GmapCustomMarker from 'vue2-gmap-custom-marker';
import { StartNavigation } from "@proteansoftware/capacitor-start-navigation";
import AnimacionCarga from '../../components/AnimacionCarga.vue'

export default {
  name: "ComerciosView2",
  data() {
    return {
      panelActivo: false,
      loading: true,
      // buscador
      filtro: "",
      // chips categorias
      listaCategoriasActivasComercios: [],
      categoriaSeleccionada: "",
      //listado completo de comercios activos
      listaComercios: [],
      //detalle comercio
      comercioSeleccionado: {},
      dialogComercios: false,
      //geoposicion
      coords: {},
    };
  },
  components: {
    'gmap-custom-marker': GmapCustomMarker,
    AnimacionCarga
  },
  computed: {
    comerciosFiltrados() {
      let filtrados = this.listaComercios;

      // Filtro búsqueda por nombre o direccion, con o sin tildes
      if (this.filtro) {
        filtrados = filtrados.filter(comercio =>
        (comercio.nombre.toLowerCase().normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .includes(this.filtro.toLowerCase().normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
          ) ||
          comercio.direccion.toLowerCase().normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .includes(this.filtro.toLowerCase().normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
            ))
        )
      }
      //filtro por categorias
      if (this.categoriaSeleccionada != 0) { //la categoria 0 es TODAS
        filtrados = filtrados.filter(comercio =>
          comercio.categoriaComercios.id === this.categoriaSeleccionada
        );
      }

      return filtrados
    },
  },
  async created() {
    await this.$store.dispatch("LoginStore/doLoginAPI");
    this.$store.dispatch("ConfigStore/setOverlay", true);
    try {
      await this.getComercios()
      await this.getPosition();
    } catch (e) {
      return e;
    }
    this.loading = false
    this.$store.dispatch("ConfigStore/setOverlay", false);
  },
  methods: {
    async getComercios() {
      const categorias = await this.$store.dispatch("ListarCategoriasActivasComercios/getListarCategoriasActivasComercios");
      const listaComercios = await this.$store.dispatch("ListarComercios/getListaComercios");

      if (categorias.status === 200) {
        this.listaCategoriasActivasComercios = categorias.data;
      }
      if (listaComercios.status === 200) {
       
        this.listaComercios = listaComercios.data;
      }
    },
    async getPosition() {
      try {
        const coordinates = await Geolocation.getCurrentPosition();
        this.coords = {
          latitude: coordinates.coords.latitude,
          longitude: coordinates.coords.longitude
        };
      } catch (error) {
        console.log(error)// eslint-disable-line
      }
    },
    async clickMarcador(comercio) {
      const foto = await this.fotosComercio(comercio.id);
      comercio.foto = foto;
      this.comercioSeleccionado = comercio;

      // Buscar el índice del comercio en la lista
      const index = this.comerciosFiltrados.indexOf(comercio);
      this.panelActivo = index;
      this.dialogComercios = true;
    },
    async clickPanel(comercio) {
      const foto = await this.fotosComercio(comercio.id);
      comercio.foto = foto;
      if (comercio.expandido) {
        comercio.expandido = false;
        this.dialogComercios = false;
      } else {
        for (const comercioExp of this.comerciosFiltrados) {
          comercioExp.expandido = (comercioExp === comercio);
          this.comercioSeleccionado = comercio;
        }
        this.dialogComercios = true;
      }
    },
    cerrarDialog() {
      this.dialogComercios = false;
      this.panelActivo = false;
    },
    async fotosComercio(idComercio) {
      const result = await this.$store.dispatch("FotosComercios/getFotosComercios", idComercio);
      if (result.status == 200) {
        return result.data[0].urlFichero;
      }
      else {
        return null;
      }
    },
    enviarEmail() {
      let direccionEmail = this.comercioSeleccionado.email;
      window.location.href = "mailto:" + direccionEmail + "?subject=Email desde la app Reusapp";
    },
    irWeb() {
      let urlComercio = this.comercioSeleccionado.web;

      if (urlComercio.indexOf("http") == -1) {
        urlComercio = 'https://' + urlComercio;
      }

      window.open(urlComercio, '_blank')
    },
    comoLlegar() {
      let latComercio = this.comercioSeleccionado.latitud;
      let lngComercio = this.comercioSeleccionado.longitud;
      let nomComercio = this.comercioSeleccionado.nombre; //el nombre creo que no hace falta

      StartNavigation.launchMapsApp({
        latitude: Number(latComercio),
        longitude: Number(lngComercio),
        name: String(nomComercio)
      });
    },
  },
  watch: {
    currentStyle: function (newStyle) {
      let parent = this
      parent.newStyle = newStyle

      this.$refs.map.$mapPromise.then((map) => {
        map.setOptions({ styles: parent.newStyle })
      })
    }
  }
};
</script>

<style scoped >
.divCerrar {
  position: absolute;

  top: 2%;
  left: 2%;
  z-index: 999;
}

.iconCerrar {

  size: 28px !important;

  background-color: #0072B9;
  height: 28px !important;
  min-width: 28px !important;
  width: 28px !important;

}

.v-dialog {
  margin: 0px !important;
}


.customDialog {
  opacity: 0 !important;
}

/* zona lateral */
.lateral {
  padding: 0px;

}

.logoEmulsa {
  width: 102px;
  height: 45px !important;

}



.panelComercios {
  overflow-y: scroll !important;
  overflow-x: hidden !important;
  height: 67vh;

}





.panelComercios::-webkit-scrollbar {
  -webkit-appearance: none;
}

.panelComercios::-webkit-scrollbar:vertical {
  width: 10px;
}

.panelComercios::-webkit-scrollbar-button:increment,
.contenedor::-webkit-scrollbar-button {
  display: none;
}

.panelComercios::-webkit-scrollbar:horizontal {
  height: 10px;
}

.panelComercios::-webkit-scrollbar-thumb {
  background-color: #797979;
  border-radius: 20px;
  border: 2px solid #f1f2f3;
}

.panelComercios::-webkit-scrollbar-track {
  border-radius: 10px;
}





.v-expansion-panel::before {
  box-shadow: none;
}

.iconExpand {
  color: #0072B9;
  transform: rotate(45deg);
  cursor: pointer;
  /* content: url("../../assets/iconos/circle-down.svg") !important; */
  /* content: url("../../assets/iconos/marcador.svg") !important; */
}

.v-expansion-panel--active>.v-expansion-panel-header--active .v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate) .v-icon {
  transform: rotate(0deg);
  /* transform: rotate(-180deg); */
  /* content: url("../../assets/iconos/circle-down.svg") !important; */
  /* content: url("../../assets/iconos/marcadorActivo.svg") !important; */
  /* fill: #67AF21 !important; */
  content: url("../../assets/iconos/minus.svg") !important;
}

.divImgComercioLista {
  max-width: 5vw !important;
}

.imagenComercioLista {
  width: 10vw;
  height: 10vh;
}

.datosTitulo {
  display: flex;
  flex-direction: column;
}

.tituloComercios {
  font-size: 18px !important;
  color: #3A3838;
  font-weight: 700;
  margin-bottom: 0;
}

.datosComercios {
  font-size: 16px !important;
  color: #3A3838;
  font-weight: 600;
  margin-bottom: 0;
}

.theme--light.v-expansion-panels .v-expansion-panel:not(:first-child):after {
  border-color: #3a38388a;
}

.logoReusapp {
  width: 13vw;

}

/* zona del mapa */

.chipsMovil {

  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-bottom: 5px !important;
}

.chips {
  width: 60vw;
  top: 7vh;
  position: absolute !important;
  z-index: 999;
}

.v-chip-group .v-chip--active {
  background-color: #0072B9;
  color: #fff !important;
}

.theme--light.v-chip:not(.v-chip--active) {
  background: #fff;
}

.v-slide-group__prev,
.v-slide-group__prev--disabled {
  background-color: #fff !important;
}


/* pruebas color de next y prev */
.fa-circle-chevron-right::before {
  background-color: #fff !important;
  fill: #0072B9 !important;
  content: url("../../assets/iconos/minus.svg") !important;
}

.fa-circle-chevron-left::before {
  background-color: #fff !important;
  fill: #0072B9 !important;
  content: url("../../assets/iconos/minus.svg") !important;
}

.v-slide-group.v-item-group>.v-slide-group__next,
.v-slide-group.v-item-group>.v-slide-group__prev {
  cursor: pointer;
  fill: #0072B9 !important;
}

.v-slide-group__next,
.v-slide-group__prev {
  filter: invert(108%);
}

/* pruebas color de next y prev */



.mapa {
  /*   
  
  top:0;
  right: 0;
  bottom: 0;
  left: 30vw;
  margin: 0;
  padding: 0;

  
  border: 2px solid rgb(211,211,211);
  border-radius: 3px; */

  min-height: 100vh !important;
  max-height: 100vh !important;
}

.marcador {
  height: 60px !important;
  width: 35px !important;
  background-image: url("../../assets/iconos/marcador.svg") !important;
  background-size: cover;
  background-position: center center;
}

.marcador-seleccionado {
  height: 85px !important;
  width: 50px !important;
  background-image: url("../../assets/iconos/marcadorActivo.svg") !important;
  background-size: cover;
  background-position: center center;
  z-index: 999 !important;
}

/* popUp comercios */
.cardComercios {
  position: absolute;
  top: 18vh;
  left: 50vw;
  width: 30vw;
  padding-bottom: 2vh;
  border-radius: 10px !important;
}

.ruta {
  position: absolute;
  right: 5%;
  z-index: 15;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  background-color: #0072B9;
  color: #fff !important;
  width: 100px;
  border-radius: 20px;
  text-transform: capitalize;
  font-size: 18px !important;
}

.imagenComercio {
  position: relative;
  z-index: 1;
  background-size: cover !important;
  background-position: center center;
  width: 100%;
  height: 30vh;
  border-radius: 10px 10px 0 0 !important;
}



.iconoX {
  font-size: 32px !important;
  background-color: #fff !important;
  padding: 0px;
  border-radius: 50%;
  position: absolute;
  z-index: 2;
  top: 3%;
  padding: 0 !important;

}

/* para quitar sombra tras el boton X */
.v-application .background--text {
  color: transparent !important;
  caret-color: transparent !important;
}

.descripcion {
  padding: 0 !important;
}

.tituloComercioPopUp {
  padding: 0 !important;
  margin-top: 1vh;
  padding-left: 1vw !important;
  padding-right: 2vw !important;
  font-weight: bold;
  word-break: break-word;
  font-size: 20px;
  line-height: 1.3;
}

.datosComercio {
  padding: 0 !important;
  margin-left: 1vw;
  font-size: 18px !important;
  font-weight: 600;
  line-height: 1.3;
}

.descripcion2 {
  padding: 0 !important;
}

.descripcionComercio {
  margin-left: 1vw;
  padding: 0 !important;
  font-size: 18px !important;
}

.btnPopUp {
  margin-left: 1vw;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.botonesDetalle {
  min-width: 15px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
}

.tlfDetalle,
.emailDetalle,
.webDetalle {
  font-size: 16px;
  font-weight: 600;
}

@media only screen and (max-width: 1280px) {
  .logoReusapp {
    width: 25vw;

  }
}
</style>
